import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { normalizeTechGrants } from './utils'

const getGrants = (state: RootState) => state.technology.rejectedGrants.data
const getLoading = (state: RootState) => state.technology.rejectedGrants.loading
const getError = (state: RootState) => state.technology.rejectedGrants.error
const getPaging = (state: RootState) => state.technology.rejectedGrants.paging

const makeRejectedGrants = createSelector([getGrants], (grants) => {
  return normalizeTechGrants(grants)
})

export const RejectedGrantsSelector = {
  getGrants,
  getLoading,
  getError,
  getPaging,
  makeRejectedGrants,
}
